import { duration } from 'src/replicant/utils/duration';
import {
  formatLocalTime,
  getLocalDate,
  getLocalTimezone,
} from 'src/replicant/utils/time';
import { Pet } from '../pet';
import type { FateStateScheduleRecord } from './fate.schema';

/**
 * Get sleeping duration from now
 */
export function getTimeUntilAwake(now: number, state: Record<string, any>) {
  const timeZone = getLocalTimezone(state);
  let awakeTime = now;
  let jstNow = getLocalDate(now, timeZone);

  const sleepingPeriod = Pet.ruleset.getSleepingPeriod(state);

  if (jstNow.getHours() >= sleepingPeriod.startHour) {
    awakeTime += duration({ hours: 24 - sleepingPeriod.startHour });
  }

  jstNow = getLocalDate(awakeTime, timeZone);

  if (jstNow.getHours() < sleepingPeriod.endHour) {
    awakeTime += duration({
      hours: sleepingPeriod.endHour - jstNow.getHours(),
      minutes: -jstNow.getMinutes(),
      seconds: -jstNow.getSeconds(),
      ms: -jstNow.getMilliseconds(),
    });
  }

  return awakeTime - now;
}

/**
 * Human readable fate state formatter
 */
export function fateToArray(
  fate: { [key: string]: FateStateScheduleRecord },
  timeZone: string,
) {
  return Object.keys(fate)
    .map((id) => ({ state: id, timestamp: fate[id].timestamp }))
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((item) => ({
      state: item.state,
      date: formatLocalTime(item.timestamp, timeZone),
    }));
}

/**
 * Human readable fate state formatter
 */
export function fateToString(
  fate: { [key: string]: FateStateScheduleRecord },
  timeZone: string,
) {
  const array = fateToArray(fate, timeZone).map(
    (item) => `${item.date} - ${item.state.toUpperCase()}`,
  );

  return array.join('\n');
}
